import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  AccurateUnassignedItem,
  GroupedUnassignedUserDataV2,
} from '@wilson/interfaces';
import { ShiftTimelineDataState } from '@wilson/shift-timeline/state';
import { GetJobNamePipe } from '../../pipes/get-job-name.pipe';
import { GetServiceNamePipe } from '../../pipes/get-service-name.pipe';
import { TimelineActivitiesOverlapLevelsPipe } from '../../pipes/timeline-activities-overlap-levels.pipe';
import { UnassignedItemWrapperComponent } from '../unassigned-item-wrapper/unassigned-item-wrapper.component';

@Component({
  selector: 'wilson-unassigned-services-and-jobs-row',
  imports: [
    UnassignedItemWrapperComponent,
    CommonModule,
    TimelineActivitiesOverlapLevelsPipe,
    GetServiceNamePipe,
    GetJobNamePipe,
  ],
  templateUrl: './unassigned-services-and-jobs-row.component.html',
  styleUrl: './unassigned-services-and-jobs-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnassignedServicesAndJobsRowComponent {
  private readonly store = inject(Store);

  @Input({
    required: true,
  })
  row!: GroupedUnassignedUserDataV2;

  public serviceIdsToHighlight$ = this.store.select(
    ShiftTimelineDataState.serviceIdsToHighlight,
  );

  openServiceInNewTab(serviceId: string): void {
    window.open(`/services/${serviceId}`, '_blank');
  }

  openJobInNewTab(jobId: string): void {
    window.open(`/share/jobs/provider/${jobId}`, '_blank');
  }

  trackByActivityIds(_: number, item: AccurateUnassignedItem): string {
    return item.activities.map((activity) => activity.id).join('');
  }
}
